import { Spin } from '@arco-design/web-react';
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export function RedirectComponent() {
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(window.location.search);
  const to = searchParams.get('to');
  const token = searchParams.get('token');

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate(`${to}?token=${token}`, { replace: true });
    }, 500);

    return () => {
      clearTimeout(timer);
    };
  }, [token, to, navigate]);

  return <Spin />;
}
